import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ServiceProvider from "./Components/Common/ContextApi/ServiceProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ServiceProvider>
    <App />
  </ServiceProvider>
);
